import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

export const UnsavedChangesModal = ({
  isOpen,
  onClose,
  onExit,
  onSave,
  isSaving = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  onSave: () => void;
  isSaving?: boolean;
}) => (
  <Modal.Root open={isOpen} onOpenChange={onClose}>
    <Modal.Content size="small">
      <StatusModal type="warning" title="Exit without saving?" showCloseButton>
        Your recent edits haven't been saved. Exiting now will discard all
        unsaved changes and cannot be undone.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Button customType="secondary" size="regular" onClick={onExit}>
          Exit
        </Button>
        <Button
          customType="primary"
          size="regular"
          onClick={onSave}
          isLoading={isSaving}
        >
          Save changes
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
